const messages = {
  en: {
    message: {
      unsupportedBrowser: {
        oops: 'Oops, something went wrong',
        explain: 'Your browser does not support the Geometric App',
        tryAgain: 'Try updating your browser first',
        contactSupport: 'Send the messages below to'
      },
      categoryWidgets: {
        incomeGroups: 'Household income distribution',
        ageGroups: 'Age groups distribution',
        revenuVariables: {
          revenu_r2248: 'Less than 30 000$',
          revenu_r2249: '30 000$ to 60 000$',
          revenu_r2250: '60 000$ to 90 000$',
          revenu_r2251: '90 000$ to 120 000$',
          revenu_r2252: 'More than 120 000$'
        },
        ageVariables: {
          age_r2253: 'Younger than 15 yrs old',
          age_r2254: 'Between 15 and 30 yrs old',
          age_r2255: 'Between 30 and 45 yrs old',
          age_r2256: 'Between 45 and 60 yrs old',
          age_r2257: 'Older than 60yrs old'
        }
      }
    }
  },
  fr: {
    message: {
      unsupportedBrowser: {
        oops: 'Oops, quelque chose est cassé',
        explain: 'Votre naviguateur ne semble pas supporté par Geometric',
        tryAgain: 'Essayez de mettre à jour votre navigateur',
        contactSupport: 'Envoyez les messages ci-dessous à : '
      },
      categoryWidgets: {
        incomeGroups: 'Répartition des tranches de revenus',
        ageGroups: 'Répartition des groupes d\'âge',
        revenuVariables: {
          revenu_r2248: 'Moins de 30 000$',
          revenu_r2249: 'de 30 000$ à 60 000$',
          revenu_r2250: 'de 60 000$ à 90 000$',
          revenu_r2251: 'de 90 000$ à 120 000$',
          revenu_r2252: 'Plus de 120 000$'
        },
        ageVariables: {
          age_r2253: 'Plus de 15 ans',
          age_r2254: 'Entre 15 et 30 ans',
          age_r2255: 'Entre 30 et 45 ans',
          age_r2256: 'Entre 45 et 60 ans',
          age_r2257: 'Plus de 60 ans'
        }
      }
    }
  }
}

export default messages
